module.exports = "/assets/delivery/dpd@2x.png?YnLmxLY";